import { BASE_URL } from 'constants/api';

import { createGetAPI } from '@cuemath/rest-api';
import { stringify } from 'query-string';

const { useGet: useGBulkStudentTransferList } = createGetAPI({
  getURL: (_, queryParam) =>
    `${BASE_URL}/students/students-teacher-transfer/?${stringify(queryParam)}`,
});

const { useGet: useGetTeacherSpecificSTList } = createGetAPI({
  getURL: (_, queryParam) =>
    `${BASE_URL}/students/teacher-students/?${stringify(queryParam)}`,
});

export { useGBulkStudentTransferList, useGetTeacherSpecificSTList };
